import { computed } from 'vue'
import { useEffectiveGardianRoles } from '~/composables/auth/useEffectiveGardianRoles'
import { useOrganigrammeEditRouteAccess } from '~/composables/auth/useOrganigrammeEditRouteAccess'
import type { OrgEditActor } from '~~/utils/auth/orgEditAffordances'

export function useOrgEditActor() {
  const { roles } = useEffectiveGardianRoles()
  const { directionAdminDirLibs, myOrgPositions, myManagerOrganigramEditScope } =
    useOrganigrammeEditRouteAccess()

  const actor = computed<OrgEditActor>(() => ({
    roles: roles.value,
    directionAdminDirLibs: directionAdminDirLibs.value,
    managerScope: myManagerOrganigramEditScope.value,
    positions: myOrgPositions.value,
  }))

  return { actor }
}
